import * as tslib_1 from "tslib";
// Order is important, do not mess with it :)
import * as React from 'react';
import { bootstrap } from 'owa-bootstrap';
import initializeMailModuleState from './actions/initializeMailModuleState';
import MailModule from 'owa-mail-module-view/lib/components/MailModule';
import { mailRouterOptions, initializeMailRoutes } from './routing/mailRoutes';
import mailStrings from 'owa-strings/owa-mail-strings';
import { runAfterInitialRender } from 'owa-delayed-initialization';
import initializeNotifications from './initializeNotifications';
import initializeServiceWorker from './initializeServiceWorker';
import initializePersona from './initializePersona';
import { mailFeatures, isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { controlFeatures } from 'owa-controls-feature-flags';
import { attachmentFeatures } from 'owa-attachment-feature-flags';
import { addInFeatures } from 'owa-addins-feature-flags';
import owaServiceFeatures from 'owa-service/lib/owaServiceFeatures';
import { Features as groupsInOwaMailFeatures } from 'owa-group-feature-flags';
import { GroupFeatures as groupsFeatures } from 'owa-group-features';
import { addToActionQueueMiddleware, legacyAddToActionQueueMiddleware } from 'owa-diagnostics';
import { controlIconRegistration } from 'owa-control-icons';
import { mailIconsRegistration } from 'owa-mail-icons';
import { addinIconsRegistration } from 'owa-addins-icons';
import { surfaceActionIconsRegistration } from 'owa-surface-action-icons';
import { initializeMailFavicon } from 'owa-mail-favicon';
import initializeNewMailNotificationFilter from './initialization/initializeNewMailNotificationFilter';
import { getMailAnalyticOptions } from 'owa-mail-shared-analytics';
import DesktopErrorComponent from 'owa-error-boundary/lib/DesktopErrorComponent';
import { logSubjectPickerInitInfo } from 'owa-mail-subject-picker-connector';
import initializeExtensibilityContext from './initializeExtensibilityContext';
import 'owa-sxs-v2-view';
import connectedAccountsNotificationOperation from 'owa-service/lib/operation/connectedAccountsNotificationOperation';
import initializeLandmarkKeyboardNavigation from './initialization/initializeLandmarkKeyboardNavigation';
import { startTrackingFps } from 'owa-fps';
export default function bootstrapMailModule(bootstrapConfig) {
    var bootstrapPromise = bootstrap({
        skipSnapshots: false,
        initializeState: initializeMailModuleState,
        renderMainComponent: function () { return React.createElement(MailModule, null); },
        packageBaseUrl: bootstrapConfig && bootstrapConfig.packageBaseUrl,
        scriptBaseUrl: bootstrapConfig.scriptBaseUrl,
        location: window.location,
        registerRoutes: initializeMailRoutes,
        routerOptions: mailRouterOptions,
        owsPath: bootstrapConfig.owsPath,
        owsPrimePath: bootstrapConfig.owsPrimePath,
        sessionDataPromise: bootstrapConfig.sessionDataPromise,
        userBootSettingsPromise: bootstrapConfig.userBootSettingsPromise,
        bootStringsPromise: bootstrapConfig.bootStringsPromise,
        flightv2Promise: bootstrapConfig.flightv2Promise,
        getModuleName: function () { return mailStrings.mailModuleName; },
        appName: bootstrapConfig.app,
        features: tslib_1.__assign({}, mailFeatures, controlFeatures, attachmentFeatures, groupsFeatures, addInFeatures, groupsInOwaMailFeatures, owaServiceFeatures),
        loadingScreenElementId: bootstrapConfig.loadingScreenElementId,
        satchelMiddleware: [addToActionQueueMiddleware],
        satchelLegacyMiddleware: [legacyAddToActionQueueMiddleware],
        workload: 1 /* Mail */,
        analyticsOptions: getMailAnalyticOptions(),
        iconFonts: [
            controlIconRegistration,
            mailIconsRegistration,
            addinIconsRegistration,
            surfaceActionIconsRegistration,
        ],
        featureOverrides: bootstrapConfig.featureOverrides,
        errorRenderingComponent: DesktopErrorComponent,
    });
    runAfterInitialRender(function () {
        if (isMailFeatureEnabled('fwk-perf-fps')) {
            startTrackingFps();
        }
        initializeNotifications();
        initializeLandmarkKeyboardNavigation();
        initializeServiceWorker(window, 'mail');
        initializePersona();
        initializeMailFavicon();
        initializeNewMailNotificationFilter();
        initializeExtensibilityContext();
        logSubjectPickerInitInfo();
        connectedAccountsNotificationOperation({
            isOWALogon: true,
        });
    });
    return bootstrapPromise;
}
//# sourceMappingURL=bootstrapMailModule.js.map